<template>
  <v-expansion-panel v-model="panel">
    <v-expansion-panel-header class="mt-2">
      Reportes de Inventario
      <template v-slot:actions>
        <v-btn class="mr-5" @click.native.stop="getFilterData()" icon small>
          <v-icon color="primary">mdi-reload</v-icon>
        </v-btn>
        <v-btn @click="$store.dispatch('deleteWindowByUuid', { uuid: win.uuid })" icon small>
          <v-icon color="error">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-tabs v-model="tab" dark background-color="primary" icons-and-text>
        <v-tabs-slider color="red"></v-tabs-slider>
        <v-tab href="#tab-1" v-if="$store.getters['rolesUser/getArrayCustomRole']([242]) || $store.getters['rolesUser/getArrayCustomRole']([252]) || $store.getters['rolesUser/isAdminOrManager']">
          Existencias
          <v-icon>mdi-package</v-icon>
        </v-tab>
        <v-tab href="#tab-6" v-if="$store.getters['rolesUser/getArrayCustomRole']([243]) || $store.getters['rolesUser/isAdminOrManager']">
          Minimos / maximos
          <v-icon>mdi-archive-cog</v-icon>
        </v-tab>
        <v-tab href="#tab-14" v-if="$store.getters['rolesUser/getArrayCustomRole']([243]) || $store.getters['rolesUser/isAdminOrManager']">
          Kardex general
          <v-icon>mdi-archive-cog</v-icon>
        </v-tab>
        <v-tab href="#tab-15" v-if="$store.getters['rolesUser/getArrayCustomRole']([243]) || $store.getters['rolesUser/isAdminOrManager']">
          Alertas por vencimiento
          <v-icon>mdi-calendar-alert</v-icon>
        </v-tab>
        <v-tab href="#tab-9" v-if="$store.getters['rolesUser/getArrayCustomRole']([243]) || $store.getters['rolesUser/isAdminOrManager']">
          Reporte de Costos
          <v-icon>mdi-cash-multiple</v-icon>
        </v-tab>
        <v-tab href="#tab-10" v-if="$store.getters['rolesUser/getArrayCustomRole']([243]) || $store.getters['rolesUser/isAdminOrManager']">
          Costos de Traspaso
          <v-icon>mdi-truck-fast</v-icon>
        </v-tab>
        <v-tab href="#tab-11" v-if="$store.getters['rolesUser/getArrayCustomRole']([243]) || $store.getters['rolesUser/isAdminOrManager']">
          Costos historico
          <v-icon>mdi-cash-multiple</v-icon>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" touchless>
        <v-tab-item value="tab-1" v-if="$store.getters['rolesUser/getArrayCustomRole']([242]) || $store.getters['rolesUser/getArrayCustomRole']([252]) || $store.getters['rolesUser/isAdminOrManager']">
          <v-card flat class="pa-1 position-relative">
            <v-card-text class="pa-0">
              <SpecialInventoryReport v-if="SpecialInventoryReport == 1" :keyR="key" :datafilter="filterData" />
              <InventoryReport v-else :key="key" :datafilter="filterData" :business="business" :isCarsem="isCarsem" />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item value="tab-6" v-if="$store.getters['rolesUser/getArrayCustomRole']([243]) || $store.getters['rolesUser/isAdminOrManager']">
          <v-card flat class="pa-1 position-relative">
            <v-card-text class="pa-0">
              <InventoyMinimumAndMaximum :key="key" :datafilter="filterData" />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item value="tab-9" v-if="$store.getters['rolesUser/getArrayCustomRole']([242]) || $store.getters['rolesUser/isAdminOrManager']">
          <v-card flat class="pa-1 position-relative">
            <v-card-text class="pa-0">
              <InventoryCostReport :key="key" :datafilter="filterData" />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item value="tab-10" v-if="$store.getters['rolesUser/getArrayCustomRole']([242]) || $store.getters['rolesUser/isAdminOrManager']">
          <v-card flat class="pa-1 position-relative">
            <v-card-text class="pa-0">
              <TransferCostsReport :key="key" />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item value="tab-11" v-if="$store.getters['rolesUser/getArrayCustomRole']([242]) || $store.getters['rolesUser/isAdminOrManager']">
          <v-card flat class="pa-1 position-relative">
            <v-card-text class="pa-0">
              <InventoryHistoricalCostReport :key="key" :datafilter="filterData" />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item value="tab-14" v-if="$store.getters['rolesUser/getArrayCustomRole']([243]) || $store.getters['rolesUser/isAdminOrManager']">
          <v-card flat class="pa-1 position-relative">
            <v-card-text class="pa-0">
              <CompleteKardex :datafilter="filterData" key="completeKardexTab" />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item value="tab-15" v-if="$store.getters['rolesUser/getArrayCustomRole']([243]) || $store.getters['rolesUser/isAdminOrManager']">
          <v-card flat class="pa-1 position-relative">
            <v-card-text class="pa-0">
              <ProductExpirationAlerts :datafilter="filterData" key="productExpirationAlertsTab" />
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import InventoryReport from "@/views/inventory/reports/InventoryReport";
import InventoyMinimumAndMaximum from "@/views/inventory/reports/InventoyMinimumAndMaximum";
import InventoryCostReport from "@/views/inventory/reports/InventoryCostReport";
import InventoryHistoricalCostReport from "@/views/inventory/reports/InventoryHistoricalCostReport";
import TransferCostsReport from "@/views/inventory/reports/TransferCostsReport.vue";
import ProductExpirationAlerts from "@/views/inventory/reports/ProductExpirationAlerts.vue";
import { mapState } from "vuex";
import SpecialInventoryReport from "../reports/SpecialInventoryReport.vue";
import CompleteKardex from "../reports/CompleteKardex.vue";
import {
  VUE_APP_CARSEM_ID_KEYMASTER1,
  VUE_APP_CARSEM_ID_KEYMASTER2,
  VUE_APP_CARSEM_ID_KEYMASTER3,
} from "@/config";

export default {
  name: "StockReport",
  components: {
    InventoryReport,
    InventoyMinimumAndMaximum,
    SpecialInventoryReport,
    InventoryCostReport,
    InventoryHistoricalCostReport,
    TransferCostsReport,
    CompleteKardex,
    ProductExpirationAlerts,
  },
  props: ["win"],
  data() {
    return {
      panel: 0,
      tab: "tab-1",
      key: 0,
      business: {},
      filterData: {
        Warehouses: [],
        Providers: [],
        Families: [],
        Categories: [],
        SubCategories: [],
        batches: [],
        providers: [],
      },
      SpecialInventoryReport: JSON.parse(localStorage.getItem("user")).SpecialInventoryReport,
      isCarsem: false,
    };
  },
  computed: {
    ...mapState("rolesUser", {
      rolesStatus: (state) => state.roles,
    }),
  },
  async mounted() {
    this.verifyCarsem();
    await this.getFilterData();
  },
  methods: {
    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    verifyCarsem() {
      const keyMastersArray = JSON.parse(this.getCookie("ID_KeyMaster"));
      const specialKeyMasters =
        keyMastersArray.includes(VUE_APP_CARSEM_ID_KEYMASTER1) ||
        keyMastersArray.includes(VUE_APP_CARSEM_ID_KEYMASTER2) ||
        keyMastersArray.includes(VUE_APP_CARSEM_ID_KEYMASTER3);
      console.log("", specialKeyMasters);
      this.isCarsem = !!specialKeyMasters;
    },
    async getFilterData() {
      try {
        const { businessid = "", branch = "" } = JSON.parse(localStorage.getItem("user"));
        const filtersWh = { business: businessid, branch };

        const [families, categories, subs, warehouses, batches, providers, business] = await Promise.all([
          this.$API.itemtypes.getFamilies(),
          this.$API.itemtypes.getCategories(),
          this.$API.itemtypes.getSubs(),
          this.$API.warehouse.getWarehousesByBusiness(filtersWh),
          this.$API.products.getAllBatch(),
          this.$API.providers.getProvidersHistory(filtersWh),
          this.$API.business.FindOne(businessid),
        ]);

        this.filterData.Families = families.map((fam) => ({ name: fam.name, value: fam.id }));
        this.filterData.Categories = categories.map((cat) => ({ name: cat.name, value: cat.id, parent_id: cat.id_family }));
        this.filterData.SubCategories = subs.map((sub) => ({ name: sub.name, value: sub.id, parent_id: sub.id_cat }));
        this.filterData.Warehouses = warehouses.map((wh) => ({ name: wh.Warehouse, value: wh.ID_Warehouse }));
        this.filterData.batches = batches.map(({ ID_ItemBatch }) => ({ name: ID_ItemBatch, value: ID_ItemBatch }));
        this.filterData.providers = providers.map((prov) => ({ name: prov.ProviderName, value: prov.ID_Provider }));
        this.business = business;
        this.key++;
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    },
  },
};
</script>

<style scoped>
.show .v-list-item {
  min-height: auto !important;
}

.filter-btn {
  position: absolute;
  top: 30px;
  left: 30px;
  z-index: 9;
}

.btn-add {
  background-color: #3498db !important;
  color: white;
}

.btnsave {
  background-color: #00a178 !important;
  color: white;
}

.btnclean {
  background-color: #f29d35 !important;
  color: white;
}

.btncontinue {
  background-color: rgba(80, 80, 80, 1) !important;
  color: white;
}

.btndelete {
  background-color: #e3191e !important;
  color: white;
}

.justified-column {
  width: 100%;
  border: 1px solid #ccc;
  padding: 10px;
  word-wrap: break-word;
}
</style>
